import { Controller } from "@hotwired/stimulus"
import { Popover } from "bootstrap"

export default class extends Controller {
  static values = {
    title: String,
    content: String
  }

  connect() {
    this.popover = new Popover(this.element, {
      trigger: 'click',
      html: true,
      sanitize: false,
      placement: 'top',
      title: this.buildTitle(),
      content: this.contentValue || ''
    })

    this.handleOutsideClick = this.handleOutsideClick.bind(this)
    this.handleCloseClick = this.handleCloseClick.bind(this)
    
    document.addEventListener('click', this.handleOutsideClick)
    
    this.element.addEventListener('shown.bs.popover', () => {
      const closeBtn = document.querySelector('.popover .popover-close-btn')
      if (closeBtn) {
        closeBtn.addEventListener('click', this.handleCloseClick)
      }
    })
  }

  disconnect() {
    document.removeEventListener('click', this.handleOutsideClick)
    this.popover?.dispose()
  }

  buildTitle() {
    return `
      <div class="popover-header-content">
        <span>${this.titleValue || ''}</span>
        <button type="button" class="popover-close-btn">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1L11 11M1 11L11 1" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
          </svg>
        </button>
      </div>
    `
  }

  handleCloseClick(event) {
    event.stopPropagation()
    this.popover.hide()
  }

  handleOutsideClick(event) {
    const popoverElement = document.querySelector('.popover')
    if (popoverElement && !popoverElement.contains(event.target) && !this.element.contains(event.target)) {
      this.popover.hide()
    }
  }
}
